// extracted by mini-css-extract-plugin
export var articles = "contributor-module--articles--10wTC";
export var article = "contributor-module--article--1ijh7";